<section class="hero is-primary">
    <div class="hero-body">
        <p class="title">
            Basic Comment App
        </p>
        <p class="subtitle">
            This is a simple interface to generate comments
        </p>
    </div>
</section>